import * as React from 'react';

const SoundEnabledIcon = ({fillColor = '#2D2756'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16}>
    <path
      fill={fillColor}
      d="M10.542 15.02a.63.63 0 0 1-.604-.103.673.673 0 0 1-.271-.563c0-.11.03-.212.093-.302s.15-.15.26-.177a6.269 6.269 0 0 0 3.063-2.27c.778-1.07 1.167-2.279 1.167-3.626a6.056 6.056 0 0 0-1.167-3.635 6.126 6.126 0 0 0-3.062-2.26.42.42 0 0 1-.26-.188.568.568 0 0 1-.094-.313c0-.236.093-.42.28-.552a.634.634 0 0 1 .595-.093 7.293 7.293 0 0 1 3.593 2.718c.91 1.285 1.365 2.726 1.365 4.323 0 1.597-.455 3.038-1.365 4.323a7.292 7.292 0 0 1-3.593 2.719ZM1.125 10.5A.607.607 0 0 1 .5 9.875v-3.75a.607.607 0 0 1 .625-.625h2.708l3.104-3.104a.578.578 0 0 1 .678-.136.57.57 0 0 1 .385.573v10.334a.57.57 0 0 1-.385.573.578.578 0 0 1-.678-.136L3.833 10.5H1.125Zm8.125 1V4.48c.75.235 1.354.68 1.813 1.332.458.653.687 1.382.687 2.188 0 .82-.23 1.549-.688 2.188A3.45 3.45 0 0 1 9.25 11.5Zm-2.5-7L4.396 6.75H1.75v2.5h2.646l2.354 2.27V4.5Z"
    />
  </svg>
);

export default SoundEnabledIcon;
